import { Component, OnInit } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-attending-leaving',
  templateUrl: './attending-leaving.component.html',
  styleUrls: ['./attending-leaving.component.scss']
})
export class AttendingLeavingComponent implements OnInit {
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;
tab = [
  {
    id: 1,
    text: this.translate.instant('AttendingLeaving.Attending_Leaving')
  },
  {
    id: 2,
    text: this.translate.instant('AttendingLeaving.excel')
  },
  {
    id: 3,
    text: this.translate.instant('AttendingLeaving.devices')
  },
  {
    id: 4,
    text: this.translate.instant('AttendingLeaving.import')
  },
  {
    id: 5,
    text: this.translate.instant('AttendingLeaving.editAttendance')
  }
];

  activetab:number=0;

  constructor(public translate:TranslateService){}
  ngOnInit(): void {
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });
  }

selectTab(e:{itemIndex:number})
{this.activetab=e.itemIndex;}

}
